<div style="box-sizing: border-box; overflow: hidden;" [@remove]="remove" (@remove.done)="onRemoveDone()">
    <div [class]="classes" role="alert">
        {{ message.text }}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onDismissClicked()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>